export const COMMUNITY_HERO_SETTING_KEY = "primary";

export const DEFAULT_COMMUNITY_MEMBER_SPOTLIGHT = {
  memberKey: "community-1",
  name: "Eliud Jimenez",
  location: "Dallas–Fort Worth area",
  quote: "“Passionate about creating harmonious spaces that inspire clarity, abundance, and well-being”",
  portraitUrl: "/media/events/eliud-jimenez.webp",
} as const;

export const DEFAULT_COMMUNITY_EVENT_HIGHLIGHT = {
  eventSlug: "hr-leaders-financial-decision-makers",
  title: "Community conversations that carry forward",
  meta: "Past Event: Aug 12, 2026",
  copy: "A focused gathering for people building meaningful work, authentic relationships, and the next chapter of their professional impact.",
  tileUrls: [
    "/media/events/safetywing-world-map.png",
    "/media/events/safetywing-logo.png",
    "/media/events/chi-alliance-restaurant-happy-hour.jpg",
  ],
} as const;

export const DEFAULT_COMMUNITY_HERO_COLLECTIONS = {
  memberSpotlights: [DEFAULT_COMMUNITY_MEMBER_SPOTLIGHT],
  eventHighlights: [DEFAULT_COMMUNITY_EVENT_HIGHLIGHT],
} as const;

export type CommunityHeroAsset = {
  src: string;
  alt: string;
};

export type CommunityMemberSpotlight = {
  memberKey: string;
  location: string;
  quote: string;
  name?: string;
  portraitUrl?: string;
  memberPhotoUrl?: string | null;
};

export type CommunityEventHighlight = {
  eventSlug: string;
  title: string;
  meta: string;
  copy: string;
  tileUrls: string[];
};

export type CommunityHeroPublicProjection = {
  memberSpotlights?: Array<{
    memberKey: string;
    name: string;
    location: string;
    quote: string;
    portraitUrl: string;
    memberPhotoUrl?: string | null;
    backgroundUrl?: string;
  }>;
  eventHighlights?: Array<{
    slug: string;
    title: string;
    meta: string;
    copy: string;
    tiles: CommunityHeroAsset[];
    backgroundUrl?: string;
  }>;
  /** Legacy first-item projection retained for existing clients. */
  member: {
    name: string;
    location: string;
    quote: string;
    portraitUrl: string;
    memberPhotoUrl?: string | null;
  };
  event: {
    slug: string;
    title: string;
    meta: string;
    copy: string;
    tiles: CommunityHeroAsset[];
    backgroundUrl?: string;
  };
};